export const SaveData = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error in save data from: ${key}`);
  }
};

export const GetData = key => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error(`Error in get data from: ${key}`);
    return null;
  }
};

export const RemoveData = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error in remove data from: ${key}`);
    return null;
  }
};
